var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-salesflow-font-dark lead-owner"},[_c('InputEditable',{attrs:{"type":"select","options":_vm.getUsers(),"field":"single_owner","value":_vm.owner,"placeholder":"Selecione","title":"Dono do Lead","url":'/lead/' + _vm.lead.hashid,"custom-class":_vm.customClass,"display-text":_vm.owner},on:{"update":_vm.update}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }